import React from 'react';
import { FadeIn } from './FadeIn';
import { ArrowRightIcon, TimerIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[90svh] flex flex-col justify-center items-center px-4 py-12 overflow-hidden bg-brand-dark" data-id="element-13">
      {/* Background Grid Effect */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#1f2937_1px,transparent_1px),linear-gradient(to_bottom,#1f2937_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)] opacity-20 pointer-events-none" data-id="element-14" />

      {/* Volt Glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[300px] bg-brand-volt/10 blur-[120px] rounded-full pointer-events-none" data-id="element-15" />

      <div className="max-w-5xl mx-auto text-center relative z-10 flex flex-col items-center mt-10" data-id="element-16">
        <FadeIn direction="down" data-id="element-17">
          <div className="inline-flex items-center gap-2 bg-brand-surface border border-brand-muted/30 px-4 py-2 rounded-full mb-8" data-id="element-18">
            <span className="flex h-2 w-2 relative" data-id="element-19">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brand-volt opacity-75" data-id="element-20"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-brand-volt" data-id="element-21"></span>
            </span>
            <span className="text-sm font-medium text-brand-muted uppercase tracking-wider" data-id="element-22">
              Oferta de Lanzamiento Activa
            </span>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-23">
          <h1 className="text-5xl sm:text-7xl md:text-8xl font-black text-white mb-6 leading-[0.9] tracking-tighter text-balance" data-id="element-24">
            Solucioná todas tus clases <br className="hidden sm:block" data-id="element-25" />
            de running{' '}
            <span className="text-brand-volt" data-id="element-26">con este Mega Pack.</span>
          </h1>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-27">
          <p className="text-lg sm:text-2xl text-gray-300 font-medium mb-10 max-w-3xl mx-auto leading-relaxed text-balance normal-case" data-id="element-28">
            El sistema definitivo para profes de running. 6 tomos,
            planificaciones listas y la estructura exacta para que tus alumnos
            vuelen y tu negocio crezca.
          </p>
        </FadeIn>

        <FadeIn delay={0.3} className="w-full max-w-md mx-auto flex flex-col gap-4" data-id="element-29">
          <a href="#oferta" className="group relative w-full bg-brand-volt hover:bg-brand-voltHover text-white font-display rounded-xl px-8 py-5 flex items-center justify-center transition-all transform hover:-translate-y-1 shadow-[8px_8px_0px_rgba(255,255,255,0.1)] hover:shadow-[12px_12px_0px_rgba(59,130,246,0.3)]" data-id="element-30">
            <span className="flex items-center gap-3 font-black text-2xl tracking-wide" data-id="element-31">
              QUIERO EL MEGA PACK
              <ArrowRightIcon className="w-6 h-6 group-hover:translate-x-1 transition-transform" strokeWidth={3} data-id="element-32" />
            </span>
          </a>

          <div className="flex items-center justify-center gap-2 text-brand-muted text-sm font-medium mt-2" data-id="element-33">
            <TimerIcon className="w-4 h-4" data-id="element-34" />
            <span data-id="element-35">Acceso inmediato • Pago único de $19.990 ARS</span>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} className="mt-16 w-full max-w-4xl mx-auto" data-id="element-36">
          <div className="relative rounded-2xl overflow-hidden border border-brand-muted/20 bg-brand-surface/50 backdrop-blur-sm p-4" data-id="element-37">
            <img src="https://cdn.magicpatterns.com/uploads/1Qr5qoyZKAMHgqqg8GePzp/heylloyd-generated-1782180747539.png" alt="Mega Pack Running" className="w-full h-auto object-contain max-h-[400px] drop-shadow-2xl" data-id="element-38" />
          </div>
        </FadeIn>
      </div>
    </section>;
}